import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5v6a8 8 0 0 1 -8 8h-6","key":"svg-0"}]]

/**
 * IconRadiusBottomRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcmFkaXVzLWJvdHRvbS1yaWdodCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTkgNXY2YTggOCAwIDAgMSAtOCA4aC02IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/radius-bottom-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconRadiusBottomRight = createReactComponent('outline', 'radius-bottom-right', 'RadiusBottomRight', __iconNode);

export default IconRadiusBottomRight;